import { render } from "./Preloader.vue?vue&type=template&id=6825f020&scoped=true"
import script from "./Preloader.vue?vue&type=script&lang=js"
export * from "./Preloader.vue?vue&type=script&lang=js"

import "./Preloader.vue?vue&type=style&index=0&id=6825f020&scoped=true&lang=css"

import exportComponent from "D:\\oomool_2019\\hands\\handsorder-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6825f020"]])

export default __exports__